import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

//获取所有语言版本
const langVersionAll = obj => new Promise((resolve,reject) => {
    const {
        token,
        lang
    } = obj
    request({
        url: apis.lang_version_all + '?token=' + token +'&lang=' + lang
    }).then(res =>{
        resolve(res);
    })
})

//删除语言版本
const deteLangVersion = obj => new Promise((resolve,reject) => {
    const {token,version} = obj
    request(
        {
        url: apis.lang_version_delete + '?token=' + token + '&version=' + version,
    }).then(res => {
        resolve(res);
    })
})

export default {
    langVersionAll,
    deteLangVersion
}



// WEBPACK FOOTER //
// ./src/service/lang_version_api.js